import { render, staticRenderFns } from "./LocalBusinesses.vue?vue&type=template&id=75952b36&scoped=true"
import script from "./LocalBusinesses.vue?vue&type=script&lang=js"
export * from "./LocalBusinesses.vue?vue&type=script&lang=js"
import style0 from "./LocalBusinesses.vue?vue&type=style&index=0&id=75952b36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75952b36",
  null
  
)

export default component.exports